import React from 'react';
import { Pressable, StyleSheet, Text, View } from 'react-native';
import { Glyph } from './Glyph';
import { theme } from '../theme';
/**
 * Admin web on a phone (#411): back arrow in the title bar (or the slim tab
 * header when sideways) that returns to the client list.
 */
export const AdminBackButton = ({ onPress, label }) => (<Pressable style={styles.backHit} onPress={onPress} accessibilityRole="button" accessibilityLabel="Back to clients" testID="admin-back-button">
    <Text style={styles.backArrow}>{'\u2039'}</Text>
    {label ? (<Text style={styles.backLabel} numberOfLines={1}>
        {label}
      </Text>) : null}
  </Pressable>);
/**
 * Selected client's name in the title bar; tap to quick-switch clients.
 */
export const AdminClientTitle = ({ name, open, onPress }) => (<Pressable onPress={onPress} accessibilityRole="button" accessibilityLabel={`${name}, switch client`} accessibilityState={{ expanded: open }} testID="admin-client-title">
    <View style={styles.titleRow}>
      <Text style={styles.title} numberOfLines={1}>
        {name}
      </Text>
      <Glyph name={open ? 'arrow_drop_up' : 'arrow_drop_down'} size={24} color={theme.colors.textTitle}/>
    </View>
  </Pressable>);
const styles = StyleSheet.create({
    backHit: {
        minWidth: 44,
        minHeight: 44,
        paddingHorizontal: 8,
        flexDirection: 'row',
        alignItems: 'center',
    },
    backArrow: {
        fontSize: 30,
        lineHeight: 32,
        color: theme.colors.accent,
    },
    backLabel: {
        marginLeft: 4,
        fontSize: 15,
        color: theme.colors.accent,
        maxWidth: 140,
    },
    titleRow: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    title: {
        fontSize: 17,
        fontWeight: '600',
        color: theme.colors.textTitle,
        maxWidth: 220,
    },
});
